import * as api from '../libs/api';

class APITools {
  public static get parseQueryParams() {
    return api.parseQueryParams;
  }
}

export default APITools;
